import React from "react";
import { Link } from "react-router-dom";
import Copyright from "../copyright/Copyright";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const accountType = useSelector((state) => state?.local?.accountType);
  const { t } = useTranslation();

  return (
    <>
      <footer className="footer comman-padding pb-0">
        <div className="bg-main comman-padding pb-0">
          <div className="container-fluid">
            <div className="row border-bottom pb-4">
              <div className="col-lg-3 col-md-12 mb-lg-0 mb-4">
                <div className>
                  <img src="/assets/img/comman/logo-text.png" alt />
                  <div className="mt-2">
                    <p className="m-0 text-white fs-16 fw-light pe-5">
                      {t(
                        "Falcon Solution is a smart, user-driven marketplace that connects buyers and sellers seamlessly. Post what you offer or request what you need—fast, flexible, and built for growth."
                      )}
                    </p>
                  </div>
                  <div className="mt-2 row">
                    <div className="col-auto">
                      <a
                        href="https://play.google.com/apps/testing/com.tgFalcon.falcon"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src="/assets/img/resources/google.svg"
                          alt="Google Play Store"
                          style={{ width: "128px", height: "38px" }}
                        />
                      </a>
                    </div>
                    <div className="col-auto">
                      <a
                        href="https://apps.apple.com/us/app/falcon-solutions/id6746935271"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src="/assets/img/resources/appstore.svg"
                          alt="Apple App Store"
                          style={{ width: "128px", height: "38px" }}
                        />
                      </a>
                    </div>
                  </div>

                  {/* <div className="mt-2 row">
                    <div className="col-auto">
                      <img src="/assets/img/comman/white-playstore.png" alt />
                    </div>
                    <div className="col-auto">
                      <img src="/assets/img/comman/white-appstore.png" alt />
                    </div>
                  </div> */}
                </div>
              </div>
              <div className="col-lg-2 col-md-2">
                <h2 className="text-white fs-16 fw-semibold">
                  {t("Our Company")}
                </h2>
                <ul className="list-unstyled mt-3 social-link">
                  <li>
                    <Link
                      to={accountType === "Buyer" ? "/" : "/seller-home"}
                      className="fs-16 fw-light text-white mb-1"
                    >
                      {t("Home")}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/about-us"
                      className="fs-16 fw-light text-white mb-1"
                    >
                      {t("About Us")}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/help-and-support"
                      className="fs-16 fw-light text-white mb-1"
                    >
                      {t("Services")}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/tender-news"
                      className="fs-16 fw-light text-white mb-1"
                    >
                      {t("Tender News")}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/help-and-support"
                      className="fs-16 fw-light text-white mb-1"
                    >
                      {t("Contact")}
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="col-lg-2 col-md-2">
                <h2 className="text-white fs-16 fw-semibold">{t("Values")}</h2>
                <ul className="list-unstyled mt-3 social-link">
                  <li>
                    <a
                      href="/privacy-policy"
                      className="fs-16 fw-light text-white mb-1"
                    >
                      {t("Privacy")}
                    </a>
                  </li>
                  <li>
                    <a
                      href="/terms-and-conditions"
                      className="fs-16 fw-light text-white mb-1"
                    >
                      {t("Terms And Conditions")}
                    </a>
                  </li>
                  <li>
                    <a
                      href="/about-us"
                      className="fs-16 fw-light text-white mb-1"
                    >
                      {t("About Us")}
                    </a>
                  </li>
                </ul>
              </div>
              <div className="col-lg-2 col-md-3">
                <h2 className="text-white fs-16 fw-semibold">{t("Account")}</h2>
                <ul className="list-unstyled mt-3 social-link">
                  <li>
                    <Link
                      to="/profile"
                      className="fs-16 fw-light text-white mb-1"
                    >
                      {t("My Account")}
                    </Link>
                  </li>
                  <li className="text-white">
                    <Link
                      to="/login"
                      className="fs-16 fw-light text-white mb-1"
                    >
                      {t("Login")}
                    </Link>
                    /
                    <Link
                      to="/select-profile"
                      className="fs-16 fw-light text-white mb-1"
                    >
                      {t("Register")}
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="col-lg-3 col-md-5">
                <h2 className="text-white fs-16 fw-semibold">{t("Support")}</h2>
                <ul className="list-unstyled mt-3 social-link">
                  <li className="fs-16 fw-light text-white mb-2">
                    Naseem Rawdah, Sulaimania Riyadh 2345 Saudi Arabia
                  </li>
                  <li className="fs-16 fw-light text-white mb-2">
                    falcon@gmail.com
                  </li>
                  <li className="fs-16 fw-light text-white mb-2">
                    +966 9890989009
                  </li>
                </ul>
              </div>
            </div>
            <Copyright />
          </div>
        </div>
      </footer>

      {/* Logout Modal */}
      <div
        class="modal fade"
        id="logoutModal"
        tabindex="-1"
        aria-labelledby="logoutModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title fs-18 fw-semibod" id="logoutModalLabel">
                Logout
              </h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy text
              ever since the 1500s,
            </div>
            <div class="modal-footer">
              <a href="/login" class="btn btn-primary w-fit px-4 pt-1">
                Okay
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
